// Module
var code = "<div class=\"dms-mapping-header\">\r\n    <h1 data-bind=\"html: getTextBlockpageTitle\"></h1>\r\n    <div data-bind=\"html: getTextBlockpageContent\" class=\"dms-textblock dms-pagecontent\"></div>\r\n</div>\r\n";
// Exports
export default code;